import React from 'react';
import ReactDOM from 'react-dom/client';
import {BiqliProvider} from '@biqli/analytics/react';
import App from './App';
import './styles.css';

const publishableKey = import.meta.env.VITE_BIQLI_PUBLISHABLE_KEY?.trim();

if (!publishableKey?.startsWith('biqli_pk_')) {
  throw new Error('Set VITE_BIQLI_PUBLISHABLE_KEY in /var/www/dev/.env.');
}

const config = {
  publishableKey,
  clientName: 'biqli-react-docs-smoke',
  clientVersion: '1.0.0',
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BiqliProvider config={config}>
      <App />
    </BiqliProvider>
  </React.StrictMode>,
);
